import { useContext, createContext } from "react";
import { useSupabase } from "@/hooks/useSupabase";
import { trpc } from "@/trpc/react";
import { inferProcedureOutput } from "@trpc/server";
import { AppRouter } from "@crew-api/server";

type CrewContextProps = {
  children: React.ReactNode;
}

export type CurrentCrewMemberType = inferProcedureOutput<AppRouter['crew']['getByUserId']>;


const CrewContext = createContext<{ currentCrewMember: CurrentCrewMemberType | null } | undefined>(undefined);

export function CrewProvider({ children }: CrewContextProps) {
  const { user } = useSupabase();

  let crewMember: CurrentCrewMemberType | null = null;

  if (user) {
    const {
      isLoading,
      data: currentCrewMember,
      error,
    } = trpc.crew.getByUserId.useQuery({ user_id: user.id });

    if (error) throw new Error(error.message);

    if (isLoading) return null;
    crewMember = currentCrewMember || null;
  }

  return (
    <CrewContext.Provider value={{ currentCrewMember: crewMember }}>
      {children}
    </CrewContext.Provider>
  );
}

export const useCrew = () => {
  const ctx = useContext(CrewContext);
  if (ctx === undefined) throw new Error("useCrew must be used within a CrewProvider");
  return ctx;
};
